"use client";

import { Vacancy } from "@entities/vacancy";
import { Collection } from "@shared/types";
import { useMemo } from "react";
import { VacancyListGridConfig } from "../../types";
import { AlgoliaVacancyListGrid } from "./algolia-vacancy-list-grid";
import { DefaultVacancyListGrid } from "./default-vacancy-list-grid";

export function VacancyListGrid({
  initialData,
  searchParams,
  config,
  path = "/lowongan-dalam-negeri/lowongan",
  initialFilters,
}: {
  initialData: Collection<Vacancy> | null;
  searchParams: any;
  config: VacancyListGridConfig;
  path?: string;
  initialFilters?: any;
}) {
  // Only keyword searches use Algolia; filters and pagination are served by the API
  const hasKeyword = useMemo(() => Boolean(searchParams?.keyword), [searchParams]);

  if (!hasKeyword && initialData) {
    return <DefaultVacancyListGrid collection={initialData} config={config} path={path} />;
  }

  return <AlgoliaVacancyListGrid config={config} path={path} initialFilters={initialFilters} />;
}
